import React from 'react';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
}

export const PageContainer: React.FC<PageContainerProps> = ({ children, className = '' }) => {
  return (
    <div className={`flex-1 w-full max-w-[1280px] mx-auto px-3 ${className}`}>
      {children}
    </div>
  );
};

export default PageContainer;
